import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 各子组件引入
import waterQuality from "./tab/waterQuality";
import file from "./tab/file";
import moment from 'moment';
import { mapActions } from 'vuex';
import { queryTabList, queryMapTab, queryBigDataById } from '@/api/api'; // 全屏

import screenfull from 'screenfull';
export default {
  components: {
    waterQuality: waterQuality,
    file: file
  },
  data: function data() {
    return {
      titleLogo: '',
      waterName: '',
      headDate: '',
      headTime: '',
      selectIndex: -1,
      selectId: -1,
      isFullscreen: false,
      atmosphereList: [],
      //环境质量一张图tab
      waterQualityList: [],
      //污染源一张图tab
      hydrologyList: [],
      //水文气象一张图tab
      workingList: [],
      //工况一张图tab
      atmosphereIndex: '',
      waterQualityIndex: '',
      hydrologyIndex: '',
      workingIndex: '',
      tabList: [// {
        //   id: 0,
        //   name: '驾驶舱',
        // },
        // {
        //   id: 1,
        //   name: '环境质量一张图',
        // },
        // {
        //   id: 2,
        //   name: '污染源一张图',
        // },
        // {
        //   id: 3,
        //   name: '水文气象一张图',
        // },
        // {
        //   id: 4,
        //   name: '工况一张图',
        // },
        // {
        //   id: 5,
        //   name: '站点一张图',
        // }
      ]
    };
  },
  created: function created() {
    var _this = this;

    console.log('enter');
    this.titleLogo = window.localStorage.getItem('titleLogo');
    this.waterName = window.localStorage.getItem('waterName'); // var reg = new RegExp('(^|&)tab=([^&]*)(&|$)')
    // var r = window.location.search.substr(1).match(reg)
    // 获取顶部导航栏配置菜单

    this.getTablist(); //   if (window.localStorage.getItem('tenant') == 2) {
    // this.selectIndex = 2
    //     this.tabList = [
    //       // {
    //       //   id: 0,
    //       //   name: '驾驶舱',
    //       // },
    //       {
    //         id: 2,
    //         name: '污染源一张图',
    //       },
    //       {
    //         id: 5,
    //         name: '站点一张图',
    //       },
    //     ]
    //   }

    if (this.$route.query && this.$route.query.selectId) {
      queryBigDataById({
        id: this.$route.query.selectId
      }).then(function (res) {
        if (res.success) {
          sessionStorage.setItem('selectId', JSON.stringify(res.result));
          setTimeout(function () {
            _this.turnTosite(true);
          }, 100);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setInterval(function () {
      var date = new Date();
      _this2.headDate = moment(date).format('YYYY年MM月DD日');
    }, 60000);
    this.getDate();
  },
  methods: _objectSpread(_objectSpread({
    getMaptab: function getMaptab() {
      var _this3 = this;

      queryMapTab({
        pageNo: 1,
        pageSize: 100,
        status: 1
      }).then(function (res) {
        if (res.success && res.result && res.result.records.length > 0) {
          res.result.records.forEach(function (item, index) {
            var obj = {};
            obj.name = item.abbreviation;
            obj.st = String(item.code);
            obj.iconfont = item.icon;

            switch (item.category) {
              case '1':
                _this3.atmosphereList.push(obj);

                break;

              case '2':
                _this3.waterQualityList.push(obj);

                break;

              case '3':
                _this3.hydrologyList.push(obj);

                break;

              case '4':
                _this3.workingList.push(obj);

                break;
            }
          });
          var state = false;

          var _loop = function _loop(i) {
            var item = res.result.records[i];

            if (_this3.$store.getters.userInfo.st && _this3.$store.getters.userInfo.st == String(item.id)) {
              _this3.tabList.forEach(function (item1, index) {
                item1.id == item.category ? _this3.selectIndex = index : '';
              });

              _this3.selectId = item.category;
              state = true;
              return "break";
            }
          };

          for (var i = 0; i < res.result.records.length; i++) {
            var _ret = _loop(i);

            if (_ret === "break") break;
          }

          !state ? _this3.initTabSelected() : '';
          console.log('atmosphereList', _this3.$store.getters.userInfo);
          console.log('atmosphereList', _this3.selectIndex);
        } else {
          _this3.initTabSelected();
        }
      }).catch(function () {
        _this3.initTabSelected();
      });
    },
    initTabSelected: function initTabSelected() {
      this.selectIndex = 0;
      this.selectId = this.tabList[this.selectIndex].id;

      if (this.$route.query.tab) {
        this.selectIndex = this.tabList.length - 1;
        this.selectId = this.tabList[this.selectIndex].id;
        this.$router.replace({
          query: ''
        });
      }
    },
    getTablist: function getTablist() {
      var _this4 = this;

      queryTabList().then(function (res) {
        // this.tabList.push(
        // 	{
        // 	  id: 0,
        // 	  name: '驾驶舱',
        // 	}
        // 	)
        if (res.length > 0) {
          res.forEach(function (item, index) {
            switch (item) {
              // case '0':
              // 	this.tabList.push(
              // 	{
              // 	  id: 0,
              // 	  name: '驾驶舱',
              // 	}
              // 	)
              // 	break;
              case '1':
                _this4.tabList.push({
                  id: 1,
                  name: '环境质量一张图'
                });

                break;

              case '2':
                _this4.tabList.push({
                  id: 2,
                  name: '污染源一张图'
                });

                break;

              case '3':
                _this4.tabList.push({
                  id: 3,
                  name: '水文气象一张图'
                });

                break;

              case '4':
                _this4.tabList.push({
                  id: 4,
                  name: '工况一张图'
                });

                break;
              // case '5':
              // 	this.tabList.push(
              // 	{
              // 	  id: 5,
              // 	  name: '站点一张图',
              // 	}
              // 	)
              // 	break;
            }
          });
          console.log(_this4.tabList);
        }

        _this4.tabList.push({
          id: 5,
          name: '站点一张图'
        }); // 获取每个一张图对应的tab部分


        _this4.getMaptab();
      });
    },
    turnTosite: function turnTosite(value) {
      if (value) {
        // for (let i = 0; i < this.tabList.length; i++) {
        // if (this.tabList[i].name == '站点一张图') {
        this.selectIndex = this.tabList.length - 1;
        this.selectId = this.tabList[this.selectIndex].id; // }
        // }
      }
    },
    getDate: function getDate() {
      var _this5 = this;

      var date = new Date();
      this.headDate = moment(date).format('YYYY年MM月DD日');
      this.headTime = moment(date).format('HH:mm:ss');
      setInterval(function () {
        var time = new Date();
        _this5.headTime = moment(time).format('HH:mm:ss');

        _this5.$forceUpdate();
      }, 1000);
    },
    // 点击头部导航栏
    onToTab: function onToTab(id, index) {
      var _this6 = this;

      this.selectIndex = index;
      this.selectId = id;
      var data;

      switch (id) {
        case 1:
          data = JSON.parse(JSON.stringify(this.atmosphereList));
          this.atmosphereList = [];
          this.$nextTick(function () {
            _this6.atmosphereList = data;
          });
          break;

        case 2:
          data = JSON.parse(JSON.stringify(this.waterQualityList));
          this.waterQualityList = [];
          this.$nextTick(function () {
            _this6.waterQualityList = data;
          });
          break;

        case 3:
          data = JSON.parse(JSON.stringify(this.hydrologyList));
          this.hydrologyList = [];
          this.$nextTick(function () {
            _this6.hydrologyList = data;
          });
          break;

        case 4:
          data = JSON.parse(JSON.stringify(this.workingList));
          this.workingList = [];
          this.$nextTick(function () {
            _this6.workingList = data;
          });
          break;
      }
    },
    fullscreen: function fullscreen() {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    },
    goHome: function goHome() {
      this.$router.push('/monitor/map');
    }
  }, mapActions(['Logout'])), {}, {
    logout: function logout() {
      var that = this;
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk: function onOk() {
          return that.Logout({}).then(function () {
            window.location.href = '/'; //window.location.reload()
          }).catch(function (err) {
            that.$message.error({
              title: '错误',
              description: err.message
            });
          });
        },
        onCancel: function onCancel() {}
      });
    }
  })
};